@if (checked) {
  <svg class="mr-[10px]" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <rect width="18" height="18" rx="9" fill="#CC0033"/>
    <circle cx="9" cy="9" r="4" fill="white"/>
  </svg>
}
@if (!checked) {
  <div class="rounded-full mr-[10px] w-[18px] h-[18px] border-[1.5px] border-[#818181] group-hover:border-[#C03]"></div>
}
